import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const CustomNumberInput = ({
  name,
  label,
  value,
  onChange,
  disabled,
  required,
  step,
  pattern,
  validations,
  validationErrors,
  type
}) => {
  const [error, setError] = useState("");

  const validate = (v) => {
    let error = "";
    // eslint-disable-next-line no-restricted-syntax
    for (const validation in validations) {
      if (!validations[validation](null, parseFloat(v))) {
        error = validationErrors[validation];
        break;
      }
    }
    setError(error);
  };

  useEffect(() => {
    validate(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = (e) => {
    const { value: v } = e.target;
    validate(v);
    onChange(name, v);
  };

  return (
    <div className="form-group">
      <label htmlFor={name}>
        {label} {required && "*"}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        step={step}
        pattern={pattern}
        className={`form-control ${error ? "is-invalid" : ""}`}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

CustomNumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pattern: PropTypes.string,
  validations: PropTypes.objectOf(PropTypes.func),
  validationErrors: PropTypes.objectOf(PropTypes.string),
  type: PropTypes.string
};

CustomNumberInput.defaultProps = {
  value: "",
  disabled: false,
  required: false,
  step: "1",
  pattern: "",
  validations: {},
  validationErrors: {},
  type: "number"
};

export default CustomNumberInput;
